// extracted by mini-css-extract-plugin
var _1 = "EoBDmSKndybHIxFTqW6p";
export { _1 as "more" }
